import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';

export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  color: ${COLORS.textMuted};
  font-size: 12px;
  font-weight: 500;
`;

export const Line = styled.span`
  flex: 1 0 0;
  height: 1px;
  background: ${COLORS.hairline};
`;
